import { StateInterface, SnackbarInterface } from "./state";

export default {
  snackbar(state: StateInterface): SnackbarInterface {
    return state.snackbar;
  },
};
